<script lang="ts">
  import ActivityButton from "./ActivityButton.svelte";

  import { selectedActivityIndex, activitiesConfig } from "../store/AppState";
</script>

{#if $selectedActivityIndex !== null}
  <div class="activity-badge-content">
    <img
      alt="activity-icon"
      src={`${__PUBLIC_PATH__}images/${$activitiesConfig[$selectedActivityIndex].thumbnail}`}
    />
    <div class="text">
      <h1>{`${$activitiesConfig[$selectedActivityIndex].title}`}</h1>
      <p>{`${$activitiesConfig[$selectedActivityIndex].description}`}</p>
    </div>
    <ActivityButton />
  </div>
{/if}

<style>
  .activity-badge-content {
    text-align: center;
    margin-top: 5dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  .activity-badge-content .text h1 {
    color: hsla(210, 61%, 42%, 1);
    text-align: center;

    font-family: "Cernobil2021";
    font-size: calc(min(3.6rem, 8vmin));
    font-style: normal;
    font-weight: 700;
    line-height: calc(min(4rem, 8.3vmin));
    margin-top: calc(min(1.6rem, 2.2vmin));
    margin-bottom: calc(min(1.2rem, 2vmin));
  }

  .activity-badge-content .text p {
    color: hsla(208, 42%, 17%, 1);
    text-align: center;

    font-family: "source-sans-pro", sans-serif;
    font-style: normal;
    font-size: calc(min(2.1rem, 4vmin));
    font-weight: 400;
    line-height: calc(min(2.8rem, 5vmin));
    margin: calc(min(0.7rem, 1.5vmin));
  }
</style>
